import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    rolecompetencyrca:[]
}

export const fetchRoleCompetencyRca = createAsyncThunk('roleCompetencyRca/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/rolecompetencyrca`)
    return response.data
  })

  export const fetchUserRoleIndicator = createAsyncThunk('competencytitleindicator/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/competencyTitleIndicator`)
    return response.data
  })

let userSlice = createSlice({
  name:'rolecompetencyrca',//Root Reducer Name
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchRoleCompetencyRca.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchRoleCompetencyRca.fulfilled,(state,action)=>{
          state.isLoading = false
          state.rolecompetencyrca = action.payload
      })
      .addCase(fetchRoleCompetencyRca.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;